// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Rrdh","actionsCol":"EnrolledClinics_actionsCol__3pedk"};